import React, {Suspense} from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import RelayService from '../service/RelayService';
import AppConfigService from '../service/AppConfigService';
import Header from './Header';
import PropTypes from "prop-types";

export default class HeaderLoader extends React.Component {

  static propTypes = {
    disableSuggest: PropTypes.bool,
    disableCartBadge: PropTypes.bool,
    disableLogin: PropTypes.bool,
    disableNavBar: PropTypes.bool,
    disableNavCategory: PropTypes.bool,
    disableNavCatalog: PropTypes.bool,
    disableNavMarketplace: PropTypes.bool,
    disableNavNews: PropTypes.bool,
    disableNavExhibitions: PropTypes.bool,
    disableNavManufacturers: PropTypes.bool,
    disableNavShops: PropTypes.bool,
    disableNavPromote: PropTypes.bool,
    disableNavRegisterAccount: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
  };

  render() {
    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
        query HeaderLoaderQuery($params: String) {
            viewer {
                ...NavBar_viewer
                ...UserSection_viewer
                ...SearchResultBar_viewer @arguments(params: $params)
            }
            suggestSearch {
                ...Suggest_suggestSearch
            }
        }
      `}
        variables={{
          params: JSON.stringify(AppConfigService.getSearchParams()),
        }}
        render={({ error, props, retry }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            return (
              <Header {...props} retry={retry} {...this.props} />
            );
          }
          return (
            <Header viewer={null} suggestSearch={null} {...this.props} />
          );
        }}
      />
    )
  }

}
